import { UpdateIncidenteDTO } from "@/application/dto/incidentes/UpdateIncidenteDTO";
import { IIncidenteRepository } from "@/domain/repositories/IIncidenteRepository";

// application/use-cases/UpdateIncidenteUseCase.ts

export class UpdateIncidenteUseCase {

    constructor(
        private repository: IIncidenteRepository
    ) {}

    async execute(id: string, data: UpdateIncidenteDTO) {
        const updateData = {
            ...data,
            tipo: typeof data.tipo === "number" ? String(data.tipo) : data.tipo,
        };

        return this.repository.update(id, updateData);
    }

}